import React from 'react';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { SanitizeHtml } from '@bd/bdcore-utilities';

function AreaSection({ area, page }) {
  return (
    <div id="area-info">
      <div className="area-section">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-7 result-media">
              <img src={get(area, 'image.contentUrl', get(page, 'page_image.contentUrl'))} alt="" />
              <img src={get(area, 'image.contentUrl', get(page, 'page_image.contentUrl'))} alt="" />

            </div>
            <div className="col-12 col-lg-5 result-content">
              <h2>Living In</h2>
              <h3>{area.name}, {area.state}</h3>
              <p dangerouslySetInnerHTML={SanitizeHtml(area.description)} />
            </div>
            <div className="top-bar" />
            <div className="bottom-bar" />
          </div>
          <div className="inset-dropshadow" />
        </div>
      </div>
    </div>
  );
}

AreaSection.propTypes = {
  area: PropTypes.object,
  page: PropTypes.object.isRequired,
};

AreaSection.defaultProps = {
  area: {},
};

export default withRouter(withData({
  area: true,
  page: 'default_area',
}, {
  required: {
    area: true,
    page: true,
  },
})(AreaSection));



// WEBPACK FOOTER //
// ./src/components/AreaSection/index.js